<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="600px">
    <v-card v-if="student">
      <v-card-title>
        <div class="d-flex align-center">
          <v-avatar size="48" color="primary" class="white--text mr-3">
            <span class="headline">{{ getInitials(student.name) }}</span>
          </v-avatar>
          <div>
            <div class="headline">{{ student.name }}</div>
            <div class="caption grey--text">ID: {{ student.id }}</div>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog" class="cursor-pointer">mdi-close</v-icon>
      </v-card-title>

      <v-card-text>
        <!-- Información de Contacto -->
        <v-row class="mb-4">
          <v-col cols="12">
            <div class="subtitle-2 font-weight-bold">Información de Contacto</div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="caption grey--text">Email</div>
            <div>{{ student.email }}</div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="caption grey--text">Teléfono</div>
            <div>{{ student.phone }}</div>
          </v-col>
        </v-row>

        <!-- Nivel de Juego -->
        <v-row class="mb-4">
          <v-col cols="12" sm="6">
            <div class="caption grey--text">Nivel</div>
            <v-chip small :color="getLevelColor(student.level)">
              {{ getLevelLabel(student.level) }}
            </v-chip>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="caption grey--text">Clínicas Inscritas</div>
            <div class="display-1 font-weight-bold info--text">{{ studentClinics.length }}</div>
          </v-col>
        </v-row>

        <v-divider class="mb-4"></v-divider>

        <!-- Clínicas Inscritas -->
        <v-row>
          <v-col cols="12">
            <div class="subtitle-2 font-weight-bold mb-3">Clínicas Inscritas</div>
            <v-timeline v-if="studentClinics.length > 0" align-top>
              <v-timeline-item
                v-for="clinic in studentClinics"
                :key="clinic.id"
                small
                color="primary"
              >
                <div class="font-weight-bold">{{ getClinicTypeLabel(clinic.type) }}</div>
                <div class="caption grey--text">{{ formatDate(clinic.date) }} - {{ clinic.time }}</div>
                <div class="mt-2 caption">
                  <v-chip x-small class="mr-1">{{ clinic.description }}</v-chip>
                </div>
              </v-timeline-item>
            </v-timeline>
            <div v-else class="caption grey--text text-center pa-4">
              Sin clínicas inscritas
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'StudentDetailDialog',
  props: {
    dialog: Boolean,
    student: Object,
    studentClinics: Array
  },
  methods: {
    closeDialog () {
      this.$emit('update:dialog', false)
    },
    getInitials (name) {
      return name.split(' ').map(n => n[0]).join('').toUpperCase()
    },
    formatDate (dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString('es-MX', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    },
    getLevelColor (level) {
      const colors = {
        basico: 'green',
        intermedio: 'orange',
        avanzado: 'red'
      }
      return colors[level] || 'grey'
    },
    getLevelLabel (level) {
      const labels = {
        basico: 'Básico',
        intermedio: 'Intermedio',
        avanzado: 'Avanzado'
      }
      return labels[level] || 'Otro'
    },
    getClinicTypeLabel (type) {
      const labels = {
        swing: 'Swing',
        putting: 'Putting',
        pitch: 'Pitch',
        full_swing: 'Swing Completo',
        short_game: 'Juego Corto'
      }
      return labels[type] || 'Otro'
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
